import {
  DatasetStyleColor,
  DatasetStyleRuleCondition,
  TDomainType,
} from '@infotech-soe/metaschema';

import {
  DatasetPresetRule,
  IFrontDatasetPreset,
} from '../../models/user-config/DisplayModeConfig';

import { TotalsConfigSanitizer } from './TotalsConfigSanitizer';
import {
  DatasetColumnFormat,
  DatasetGridColumn,
} from './view-model/DatasetGridColumn';

const DEFAULT_COLORS: DatasetStyleColor = { color: '', backgroundColor: '' };
const DEFAULT_COMMAND = 'edit' as const;

const DEFAULT_CONDITION_VALUES = {
  isApplyRuleToRow: false,
  textBold: false,
  textItalic: false,
  textUnderline: false,
  textLineThrough: false,
  empty: false,
  notEmpty: false,
};

export const generateDefaultCondition = (
  type: TDomainType
): DatasetStyleRuleCondition => {
  switch (type) {
    case DatasetColumnFormat.STRING:
      return {
        value: {
          pattern: null,
          caseSensitive: false,
          ...DEFAULT_CONDITION_VALUES,
        },
        color: { ...DEFAULT_COLORS },
      };
    case DatasetColumnFormat.ENUM:
      return {
        value: { scope: [], ...DEFAULT_CONDITION_VALUES },
        color: { ...DEFAULT_COLORS },
      };
    default:
      return {
        value: { before: null, after: null, ...DEFAULT_CONDITION_VALUES },
        color: { ...DEFAULT_COLORS },
      };
  }
};

const generateDefaultRule = (
  currentColumn: DatasetGridColumn
): DatasetPresetRule => ({
  visibility: true,
  conditions: [generateDefaultCondition(currentColumn.domain.type)],
});

export const recoverPreset = (
  preset: IFrontDatasetPreset,
  columns: DatasetGridColumn[]
): IFrontDatasetPreset => ({
  ...preset,
  totals: new TotalsConfigSanitizer(
    preset.totals,
    columns.map(({ field }) => field)
  ).getCleanedConfig(),
  rules: Object.fromEntries(
    columns.map(column => [
      column.field,
      preset.rules[column.field] || generateDefaultRule(column),
    ])
  ),
  defaultCommand: preset.defaultCommand ?? DEFAULT_COMMAND,
});

const createRulesFrom = (
  columns: DatasetGridColumn[]
): Record<string, DatasetPresetRule> =>
  Object.fromEntries(
    columns.map(column => [column.field, generateDefaultRule(column)])
  );

export const createDefaultPreset = (
  columns: DatasetGridColumn[]
): IFrontDatasetPreset => ({
  pinned: 0,
  rules: createRulesFrom(columns),
  defaultCommand: DEFAULT_COMMAND,
});
